export interface IOperationFilter {
    from: String;
    to: String;

    limit: number;
    searchAfter: string;

    status: OperationMessageStatus | null;
}

export interface IOperationStatisticPagingResult {
    Total?: number;
    Items?: Array<IOperationStatistic>;
}

export interface IOperationStatisticModelPagingResult {
    Total?: number;
    Items?: Array<IOperationStatisticModel>;
}

export interface IImportResult {
    Success: boolean;
    ErrorsCount: number;
    FileName: string;
    ErrorItems: IImportResultError[];
    Operation: IOperationStatistic;
    OperationModel: IOperationStatisticModel;
}

export interface IImportResultError {
    Message: string;
    Items: IImportResultEntry[];
}

export interface IImportResultEntry {
    ID: string;
    Title: string;
    Colour: string;
    Size: string;
}

export interface IOperationStatistic {
    ID: string;
    RetailerID: number;
    ClientID: string;
    RequestTimeStamp: Date;
    Duration: string;

    Source: OperationMessageSource;
    Kind: OperationMessageKind;
    Status: OperationMessageStatus;
    Result: OperationMessageResult;

    ItemsCount: number;
    ItemsUpdatedCount: number;
    ItemsAddedCount: number;

    ErrorsCount: number;
    ConflictsCount: number;
}

export interface IOperationStatisticModel {
    ID: string;
    RetailerID: number;
    ClientID: string;
    RequestTimeStamp: Date;
    FinishedAt: Date;

    Source: string;
    Kind: string;
    Status: OperationMessageStatus;
    Result: OperationMessageResult;

    ItemsCount: number;
    ItemsUpdatedCount: number;
    ItemsAddedCount: number;

    ErrorsCount: number;
    ConflictsCount: number;
}

export interface IOperationStatisticsDetailed extends IOperationStatistic {
    Errors: IValidationError[];
}

export interface IOperationStatisticDetailedModel extends IOperationStatisticModel {
    Errors: IValidationError[];
}

export interface IValidationError {
    ProductID: string;
    VariantID: string;
    ErrorCode: number;
}

export enum OperationMessageKind {
    FullUpdate = 0,
    PriceUpdate,
    VariationArchive,
    FullUpdateReplace,
    StockQuantityUpdate,
    ProductsImportBySku
}

export enum OperationMessageStatus {
    Enqueued = 1,
    Processing,
    Processed
}

export enum OperationMessageSource {
    API = 1,
    CSV
}

export enum OperationMessageResult {
    None = 1,
    Success,
    Warning,
    Error
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/models/index.ts